module.exports = __webpack_public_path__ + "img/VideoThumbnail.1164d06a.png";